import React from 'react'
import MakeRequest from '../../modules/requests/makeRequest/MakeRequestModal'
import Dialog from '../dialog/Dialog'
import { connect } from 'react-redux'
import { RootState } from '../../modules/reducers'
import { hideModal } from '../../modules/reducers/modal/actions'
import { modalTypes } from '../../enums/modalTypeEnum'
import { getModalContent, isModalVisible } from '../../modules/reducers/modal/selector'

interface Store {
	isOpen: boolean,
	modalContent: any,
	hideModal: (modalTypes: string) => void
}

const RequestModal: React.FC<Store> = (
	{
		isOpen,
		modalContent,
		hideModal
	}
) => {

	const onCloseDialog = () => {
		hideModal(modalTypes.demandes)
		if (modalContent.callback) {
			modalContent.callback()
		}
	}

	return (
		<Dialog
			onCloseDialog={onCloseDialog}
			open={isOpen}
		>
			<MakeRequest
				closeDialog={onCloseDialog}
			/>
		</Dialog>
	)
}
const mapStateToProps = (state: RootState) => (
	{
		isOpen: isModalVisible(state, modalTypes.demandes),
		modalContent: getModalContent(state, modalTypes.demandes),
	}
)

const mapDispatchToProps = {
	hideModal
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestModal)
